import { createSlice } from '@reduxjs/toolkit';

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    userDetailsData: {},
    userDetailsDataIsLoading: false,
    userDetailsDataErrorMsg: null,
  },
  reducers: {
    userDetailsReq: (state, action) => { },
    userDetailsSuccess: (state, action) => ({
      ...state,
      userDetailsData: action.payload,
      userDetailsDataIsLoading: false,
      userDetailsDataErrorMsg: null,
    }),
    userDetailsFailure: (state, action) => ({
      ...state,
      userDetailsDataIsLoading: false,
      userDetailsDataErrorMsg: action.payload,
    }),
    userDetailsLoading: (state) => ({
      ...state,
      userDetailsDataIsLoading: true,
      userDetailsDataErrorMsg: null,
    }),
    userDetailsClear: (state) => ({
      ...state,
      userDetailsData: {},
      userDetailsDataIsLoading: false,
      userDetailsDataErrorMsg: null,
    }),
  },
});

export const {
  userDetailsClear,
  userDetailsFailure,
  userDetailsLoading,
  userDetailsReq,
  userDetailsSuccess,
} = usersSlice.actions;

export default usersSlice.reducer;
